"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var icns_file_header_1 = require("./icns-file-header");
var icns_image_1 = require("./icns-image");
var Icns = /** @class */ (function () {
    function Icns(fileHeader, images) {
        if (fileHeader === void 0) { fileHeader = new icns_file_header_1.IcnsFileHeader(); }
        if (images === void 0) { images = []; }
        this._fileHeader = fileHeader;
        this._images = images;
    }
    /**
     * Create ICNS from the icon buffer.
     * @param buffer The ICNS icon buffer.
     */
    Icns.from = function (buffer) {
        var fileHeader = icns_file_header_1.IcnsFileHeader.from(buffer);
        var pos = fileHeader.data.length;
        var images = [];
        while (pos < fileHeader.bytes) {
            var image = icns_image_1.IcnsImage.from(buffer.slice(pos));
            images.push(image);
            pos += image.data.length;
        }
        return new Icns(fileHeader, images);
    };
    Object.defineProperty(Icns.prototype, "fileHeader", {
        get: function () {
            return this._fileHeader;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icns.prototype, "images", {
        get: function () {
            return this._images;
        },
        set: function (images) {
            this._images = images;
            var bytes = this._fileHeader.data.length +
                this._images.reduce(function (carry, image) { return carry + image.bytes; }, 0);
            this._fileHeader = new icns_file_header_1.IcnsFileHeader('icns', bytes);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Icns.prototype, "data", {
        get: function () {
            var buffers = __spreadArrays([
                this._fileHeader.data
            ], this._images.map(function (image) { return image.data; }));
            return Buffer.concat(buffers);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds ICNS image at the end.
     * @param image The ICNS Image to append.
     */
    Icns.prototype.append = function (image) {
        this.images = __spreadArrays(this.images, [image]);
    };
    /**
     * Inserts ICNS image at the specified position.
     * @param image The ICNS Image to insert.
     * @param index The position at which to insert the ICNS Image.
     */
    Icns.prototype.insert = function (image, index) {
        this.images = __spreadArrays(this.images.slice(0, index), [
            image
        ], this.images.slice(index + 1));
    };
    /**
     * Removes ICNS image at the specified position.
     * @param index The position of the ICNS Image to remove.
     */
    Icns.prototype.remove = function (index) {
        this.images = __spreadArrays(this.images.slice(0, index), this.images.slice(index + 1));
    };
    Icns.supportedIconTypes = [
        { osType: 'is32', size: 16, format: 'RGB' },
        { osType: 'il32', size: 32, format: 'RGB' },
        { osType: 'ih32', size: 48, format: 'RGB' },
        { osType: 'it32', size: 128, format: 'RGB' },
        { osType: 's8mk', size: 16, format: 'MASK' },
        { osType: 'l8mk', size: 32, format: 'MASK' },
        { osType: 'h8mk', size: 48, format: 'MASK' },
        { osType: 't8mk', size: 128, format: 'MASK' },
        { osType: 'ic04', size: 16, format: 'ARGB' },
        { osType: 'ic05', size: 32, format: 'ARGB' },
        { osType: 'icp4', size: 16, format: 'PNG' },
        { osType: 'icp5', size: 32, format: 'PNG' },
        { osType: 'icp6', size: 64, format: 'PNG' },
        { osType: 'ic07', size: 128, format: 'PNG' },
        { osType: 'ic08', size: 256, format: 'PNG' },
        { osType: 'ic09', size: 512, format: 'PNG' },
        { osType: 'ic10', size: 1024, format: 'PNG' },
        { osType: 'ic11', size: 32, format: 'PNG' },
        { osType: 'ic12', size: 64, format: 'PNG' },
        { osType: 'ic13', size: 256, format: 'PNG' },
        { osType: 'ic14', size: 512, format: 'PNG' }
    ];
    return Icns;
}());
exports.Icns = Icns;
